import { render, staticRenderFns } from "./barChartVertical.vue?vue&type=template&id=dccbe4de&"
import script from "./barChartVertical.vue?vue&type=script&lang=js&"
export * from "./barChartVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports